import React from 'react';
import { isNil } from 'lodash';

import { RCStarRating } from '@reverbdotcom/cadence/components';
import {
  CoreItem2CspReviews,
} from '../schemas/rql';

interface IProps {
  csp: CoreItem2CspReviews.Csp;
}

export function Item2CspReviewsStarRating({ csp }: IProps) {
  const rating = csp.reviews.avgRating;
  const ratingCount = csp.reviews.total;
  const shouldRenderStarRating = !(isNil(rating) || isNil(ratingCount));

  return (
    shouldRenderStarRating && (
      <span className="item2__star-rating">
        <RCStarRating
          rating={rating / 5}
          count={ratingCount}
          hideTooltip
        />
      </span>
    )
  );
}
